/**
 * ADRE Online Licensing System Web API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BadAnswerModel } from './badAnswerModel';


/**
 * Submit broker audit questionnaire
 */
export class SubmitBrokerAuditQuestionnaireRequestModel { 
    /**
     * ADRE WorkflowID returned in StarFunction service
     */
    WorkflowID: number;
    /**
     * The current step in the workflow from the UI perspective used for validation purposes
     */
    CurrentStepIndex: number;
    /**
     * Broker Audit answers
     */
    Answers: Array<BadAnswerModel>;
    /**
     * Set to True when saved as a draft by the user. Set to False when submitted during continuation to the Questionnaire
     */
    SubmitAsDraft: boolean;
    /**
     * Broker Audit comments
     */
    AdditionalInformationComments?: string;
}



// WEBPACK FOOTER //
// ./src/app/model/submitBrokerAuditQuestionnaireRequestModel.ts